import { render, staticRenderFns } from "./FallskjermSe.vue?vue&type=template&id=7b48ed5c&"
import script from "./FallskjermSe.vue?vue&type=script&lang=js&"
export * from "./FallskjermSe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports